<div id="kt_connection-create__drawer"
     [perfectScrollbar]="{wheelPropagation: true, suppressScrollX: true}"
     class="offcanvas offcanvas-right p-10 connection-canvas offcanvas-on">
     <div class="offcanvas-content pr-5 mr-n5">
        <div class="d-flex justify-content-between align-items-center mb-5">
            <div class="d-flex">
                <div class="panel-nav_icon d-inline-flex">
                    <button class="btn backbtn"
                            (click)="closeDrawer()">
                        <i class="fa fa-arrow-left"></i><span>{{ l('Back') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="navi navi-spacer-x-0 p-0">
        <form
            #connectForm="ngForm"
            role="form"
            novalidate
            (submit)="connect()"
            class="connection-form form"
        >
            <div class="col-md-12 mt-10 mb-10">
                <span class="subTitle">{{ l('CreateNewConnection') }}</span>
                <div class="subText">
                    <span>{{ l('CreateNewConnectionText') }}</span>
                </div>
            </div>
            <div class="col-md-12 mb-10">
                <div class="form-group">
                    <label class="bold col-md-3 p-0" for="SiteURL">{{ l('SiteURL') }}</label>
                    <div class="col-md-9 p-0">
                        <input type="text"
                            #siteUrlInput="ngModel"
                            class="form-control"
                            id="SiteURL"
                            placeholder="https://{domain}.sharepoint.com/sites/{sitename}"
                            [(ngModel)]="site_url"
                            name="site_url"
                            required
                            />
                        <validation-messages [formCtrl]="siteUrlInput"></validation-messages>
                    </div>
                </div>
            </div>

            <div class="col-md-12 mb-10">
                <div class="form-group">
                    <label class="bold col-md-3 p-0" for="ClientID">{{ l('ClientID') }}</label>
                    <div class="col-md-9 p-0">
                        <input type="text"
                            #clientIDInput="ngModel"
                            class="form-control"
                            id="ClientID"
                            placeholder="##################"
                            [(ngModel)]="client_id"
                            name="client_id"
                            required
                            />
                        <validation-messages [formCtrl]="clientIDInput"></validation-messages>
                    </div>
                </div>
            </div>

            <div class="col-md-12 mb-15">
                <div class="form-group">
                    <label class="bold col-md-3 p-0" for="ClientSecret">{{ l('ClientSecret') }}</label>
                    <div class="col-md-9 p-0">
                        <input type="text"
                            #clientSecretInput="ngModel"
                            class="form-control"
                            id="ClientSecret"
                            placeholder="##################"
                            [(ngModel)]="client_secret"
                            name="client_secret"
                            required
                            />
                        <validation-messages [formCtrl]="clientSecretInput"></validation-messages>
                    </div>
                </div>
            </div>

            <div class="col-md-12 buttonSt mb-15">
                <button class="btn btn-secondary" (click)="testConnection()" [disabled]="!connectForm.form.valid"
                [buttonBusy]="testConnecting"
                [busyText]="l('ConnectingWithThreeDot')">{{ l('TestConnection') }}</button>

                <button type="submit" class="btn btn-primary" (click)="connect()" [disabled]="!connectForm.form.valid || !testConnectionStatus"
                [buttonBusy]="connecting" [busyText]="l('ConnectingWithThreeDot')"
                >{{ l('Connect') }}</button>
            </div>
      </form>
    </div>
</div>
